var React = require('react');
import { Box, Container, Grid } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import CheckIcon from '@mui/icons-material/Check';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import Week from './TimesheetItems/week';
import {logger} from 'utils';

const Home = () => {
  
    return (
        <div className="homeContent">
            <div className="ContainerParent">
                <div className="Container">
                    <div className="ContainerTitle">
                        <h2 style={{ margin: "0" }}>Log Time</h2>
                    </div>
                    <div className="ContainerBody">
                        <Week />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Home;